import type { FormikErrors } from 'formik'
import {
  WorkPostSheetFormStep,
  WPS_FORM_STEP_FIELDS,
  WPS_FORM_STEP_ITEMS
} from '../constants/wpsFormSteps'
import type { WorkPostSheetFormValues } from '../providers/FormProvider'

// Returns the first step that renders a field with a validation error, or undefined when the form is valid.
export const getFirstWPSFormStepWithError = (
  errors: FormikErrors<WorkPostSheetFormValues>,
  values: WorkPostSheetFormValues
): WorkPostSheetFormStep | undefined => {
  const fieldsWithError = Object.keys(
    errors
  ) as (keyof WorkPostSheetFormValues)[]

  if (fieldsWithError.length === 0) {
    return undefined
  }

  // items errors are an array aligned with values.items
  const itemNamesWithError = Array.isArray(errors.items)
    ? errors.items
        .map((itemError, index) =>
          itemError ? values.items[index]?.name : null
        )
        .filter(Boolean)
    : []

  const steps = Object.keys(WPS_FORM_STEP_FIELDS).map(
    Number
  ) as (keyof typeof WPS_FORM_STEP_FIELDS)[]

  const stepWithError = steps.find(
    step =>
      WPS_FORM_STEP_FIELDS[step].some(field =>
        fieldsWithError.includes(field)
      ) ||
      WPS_FORM_STEP_ITEMS[step].some(name => itemNamesWithError.includes(name))
  )

  // fallback for errors not mapped to a step, so the user is never stuck on the overview
  return stepWithError ?? WorkPostSheetFormStep.Step1
}
